module.exports = __webpack_public_path__ + "static/media/kredyt_32.9228e437.png";